if (!customElements.get('collection-sort-hero')) {
  class CollectionSortHero extends HTMLElement {
    constructor() {
      super();
      this.handleSortChangeRef = this.handleSortChange.bind(this);
    }

    handleSortChange(event) {
      if (!event.target.value) return;

      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      const urlString = url.toString();

      fetch(urlString)
        .then((res) => res.text())
        .then((data) => {
          document.dispatchEvent(
            new CustomEvent('exo:update-collection-items', {
              detail: {
                id: this.getAttribute('data-id'),
                html: data,
              },
            })
          );
          history.replaceState({}, '', urlString);
        })
        .catch((err) => console.error(err));
    }

    connectedCallback() {
      this.addEventListener('change', this.handleSortChangeRef);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleSortChangeRef);
    }
  }

  customElements.define('collection-sort-hero', CollectionSortHero);
}
